import { useState } from "react";
import CircularProgressWithLabel from "./circular=progress-with-label";
import SearchIcon from '@mui/icons-material/Search';
import { analyzeSingleImage } from "../../../../Services/AIListingCreation";

const Url = process.env.REACT_APP_URl;

const AnalyseImage: React.FunctionComponent<{
    idImage: number;
    processId: string;
    onAnalysisComplete: (data: any, isError: boolean, msg: string) => void;
}> = (props) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [progress, setProgress] = useState<number>(0);

    const AnalyseImg = async () => {
        setIsProcessing(true);
        setProgress(0);

        try {
            const resp = await analyzeSingleImage(
                props.processId,
                props.idImage
            );

            const eventSource = new EventSource(
                `${Url}/single_image_progress/${props.processId}/${props.idImage}`
            );

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);

                    if (data?.image?.analysisProgress !== undefined) {
                        setProgress(data.image.analysisProgress);
                    }

                    if (data?.image?.analysisComplete) {
                        props.onAnalysisComplete(data, false, "");
                        setIsProcessing(false);
                        setProgress(100);
                        eventSource.close();
                    }

                    if (data.error) {
                        props.onAnalysisComplete("", true, "Analysis failed. Please try again.");
                        setIsProcessing(false);
                        eventSource.close();
                    }
                } catch (err) {
                     eventSource.close();
                    console.error("Error parsing SSE message:", err);
                }
            };

            eventSource.onerror = () => {
                props.onAnalysisComplete("", true, "Connection lost. Please retry.");
                setIsProcessing(false);
                eventSource.close();
            };

        } catch (error: any) {
            if (error.response && error.response.status === 401) {
                props.onAnalysisComplete("", true, error.response.data.message);
            } else {
                props.onAnalysisComplete("", true, error.response.data.error);
            }
            setIsProcessing(false);
        }
    };

    return (
        <div className="analyze-box">
            {isProcessing ? (
                <CircularProgressWithLabel value={progress} text="Your photo is being analyzed" />
            ) : ( 
                <button
                    className="button-dash border-trans color-FFFFFF padd-12 mt-2 center-btn analyze-button-animated"
                    onClick={AnalyseImg}
                >
                    <SearchIcon style={{ marginRight: '8px', fontSize: '18px' }} />
                    Analyze
                </button>
            )}
        </div>
    );
};

export default AnalyseImage;